
import * as types from '../constants/actionTypes';

const initialState = {
    projectManagers: []
};

export default function projectsReducer(state = initialState, action) {
    switch(action.type) {
        case types.SET_PROJECTMANAGER_FILTER: {                
            return Object.assign({}, state, {projectManagers: action.payload.projectManagers});
        }
        default:
            return state;
    }
}